// extracted by mini-css-extract-plugin
module.exports = {"sortIcons":"sortIcons_3ftsO","light":"light_21H40","dark":"dark_3IF9_"};